export default IconGlass => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-glass" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 21l8 0" />
  <path d="M12 15l0 6" />
  <path d="M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z" />
</svg>`;